import BlogTwentyFiveContainer from "./container/BlogTwentyFiveContainer";
export default BlogTwentyFiveContainer;
